module.exports = __webpack_public_path__ + "caace95a533d53dd2dbe7cc0d4ae9d37.png";